import React, { useState } from 'react';
import s from './DataErrorItem.module.scss';
import Icon from '../Icon/Icon';

import { t } from '../../i18n';
import classNames from 'classnames';
import { AnimateUpDown } from '../Animate';

const DataErrorItem = ({ title, description, detail, icon, links }) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const classes = classNames(
        s.Root,
        { [s['Root--HasDetails']]: detail },
        { [s['Root--DetailsOpen']]: isDetailsOpen }
    );
    return (
        <div className={classes}>
            <div className={s.Container}>
                {icon && (
                    <div className={s.Image}>
                        <Icon name={icon} />
                    </div>
                )}
                <div className={s.Text}>
                    <h3 className={s.Title}>{title}</h3>
                    <span className={s.Description}>{description}</span>
                    {detail && (
                        <div className={s.Accordion}>
                            <button
                                className={s.AccordionButton}
                                onClick={() =>
                                    setIsDetailsOpen(!isDetailsOpen)
                                }>
                                <Icon name="ArrowRight" />
                                <span>{t('general.showDetails')}</span>
                            </button>
                            <AnimateUpDown isVisible={isDetailsOpen}>
                                <div className={s.Detail}>{detail}</div>
                            </AnimateUpDown>
                        </div>
                    )}

                    {/* {links && (
                        <div className={s.Links}>
                            {links.map((link, index) => (
                                <Button
                                    key={index}
                                    modifier="Secondary"
                                    size="Large"
                                    {...link}
                                />
                            ))}
                        </div>
                    )} */}
                </div>
            </div>
        </div>
    );
};

DataErrorItem.propTypes = {};

export default DataErrorItem;
